import { useCallback } from 'react';

const SPECIAL_KEYS = new Set([
  'Backspace',
  'Tab',
  'ArrowLeft',
  'ArrowRight',
  'Delete',
]);

export default function useInputPatternValidation(pattern: RegExp) {
  const isPatternMatch = useCallback(
    (value: string) => {
      return pattern.test(value) || !value;
    },
    [pattern],
  );

  const onKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      const key = e.key;

      if (!SPECIAL_KEYS.has(key) && !pattern.test(key)) {
        e.preventDefault();
      }
    },
    [pattern],
  );

  return { isPatternMatch, onKeyDown };
}
